/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import Slider from "react-slick";
import Pending_fill from "../../assets/Image/Pending_fill.png";
import processing_grey from "../../assets/Image/processing_grey.png";
import processing_fill from "../../assets/Image/Processing_fill.png";
import route_grey from "../../assets/Image/route_grey.png";
import route_fill from "../../assets/Image/route-fill.png";
import cancel from "../../assets/Image/cancel.png";
import complete_fill from "../../assets/Image/complete_fill.png";
import complete_grey from "../../assets/Image/complete_grey.png";
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import { applyImageFallback, buildImageUrl } from '../../utils/image';

export const ImgLoad = ({ url, Customestyle }) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    return (
        <img
            src={url}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={(e) => {
                applyImageFallback(e, process.env.REACT_APP_IMG_BASE_URL || process.env.REACT_APP_API_BASE_URL || "https://portal.rapidmedik.com", "package");
                setImgLoaded(true);
            }}
            className={`${Customestyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    )
}

const OrderDetails = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);
    const { orderId } = useParams();

    const [isInfo, setIsInfo] = useState();
    const [productList, setProductList] = useState([]);
    const [isShowPhoto, setIsShowPhoto] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const [lightBox, setLightBox] = useState([]);
    const [lightBoxIndex, setLightBoxIndex] = useState("");

    const Userid = secureLocalStorage.getItem("Userid");
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const settings = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/product_order_detail`, { uid: Userid, order_id: orderId })
                .then((res) => {
                    // console.log("product_order_detail", res);
                    setLoading(false);
                    setIsInfo(res.data.order_detail);
                    setProductList(res.data.product_list);
                    const product = res.data.product_list;
                    for (let i = 0; i < product?.length; i++) {
                        if (product[i].prescription_require === "Required") {
                            setIsShowPhoto(true);
                        }
                    }
                    const Data = [];
                    const Object = res.data.order_detail.medicine_prescription;
                    for (let i = 0; i < Object.length; i++) {
                        Data.push({ src: ImgBaseUrl + Object[i] });
                    }
                    setLightBox(Data);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, []);

    return (
        <div>
            {false ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
                : <div className="order_details">
                    <h1 className='font-[500] text-[20px] text-center'>{t("Order ID")} : #{orderId}</h1>
                    <div className="flex flex-wrap items-start justify-center gap-[20px] mt-[20px]">
                        <div className="width_box">

                            <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px]">
                                <h1 className='font-[500] text-[#0d9488]'>{t("Order Info")}</h1>
                                {productList?.map((item, index) => {
                                    return <div key={index} className={`py-[5px] ${index >= 1 && "border-t-[1px] border-[#8080803b]"}`}>
                                        <div className="flex items-center gap-[10px] justify-between">
                                            <div className="flex items-center gap-[10px]">
                                                <div className="border-[2px] p-[5px] border-[#8080803b] rounded-[100%]">
                                                    <ImgLoad url={buildImageUrl(ImgBaseUrl, item.product_image, "package")} Customestyle="w-[60px] h-[60px] rounded-[100%]" />
                                                </div>
                                                <div className="leading-[18px]">
                                                    {item.prescription_require === "Required" && <h1 className='font-[500] text-[red] text-[14px]'>{t("Prescription Required")}</h1>}
                                                    <h1 className='font-[500] text-[17px]'>{item.product_name}</h1>
                                                    <span className='text-gray-500'>{item.price_detail.title}</span>
                                                    <div className="flex items-center gap-[10px]">
                                                        <h1 className='font-[500] text-[18px]'>{currency}{item.price_detail.price}</h1>
                                                        <span className='line-through text-gray-500'>{currency}{item.price_detail.bprice}</span>
                                                        <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500] py-[2px]'>{item.price_detail.discount}% {t("OFF")}</h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="leading-[20px] text-end">
                                                <span className='text-gray-500'>{item.pro_type}</span>
                                                <h1 className='font-[500]'>{t("Qty")}</h1>
                                                <h1 className='font-[500] text-gray-600'>{item.price_detail.qty}</h1>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>

                            {isShowPhoto && <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                <h1 className='font-[500] text-[#0d9488] text-[17px]'>{t("Medicine Prescription")}</h1>
                                <div className="">
                                    <div className="slider-container mt-[10px]">
                                        <Slider {...settings}>
                                            {isInfo?.medicine_prescription.map((item, index) => {
                                                return <div key={index} onClick={() => { setIsShow(true); setLightBoxIndex(index) }} className="cursor-pointer">
                                                    <ImgLoad url={buildImageUrl(ImgBaseUrl, item, "package")} Customestyle="w-[100%] h-[120px] object-cover rounded-[10px]" />
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="width_box">

                            <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px]">
                                <h1 className='font-[500] text-[#0d9488] text-[17px]'>{t("Order Status")}</h1>
                                <div className="flex items-center order_status gap-[5px] justify-between">

                                    <div className="text-center">
                                        <img src={Pending_fill} alt="Pending" />
                                        <h1 className='text-[14px]'>{t("Pending")}</h1>
                                    </div>
                                    <span className={`${isInfo?.status < "1" ? "text-[gray]" : "text-black"}`}>- - -</span>

                                    <div className="text-center">
                                        <img src={(isInfo?.status < "1" || isInfo.status === "4") ? processing_grey : processing_fill} alt="Processing" />
                                        <h1 className={`${(isInfo?.status < "1" || isInfo.status === "4") ? "text-[gray]" : "text-black"} text-[14px]`}>{t("Processing")}</h1>
                                    </div>

                                    <span className={`${(isInfo?.status < "2" || isInfo.status === "4") ? "text-[gray]" : "text-black"}`}>- - -</span>

                                    <div className="text-center">
                                        <img src={(isInfo?.status < "2" || isInfo.status === "4") ? route_grey : route_fill} alt="On Route" />
                                        <h1 className={`${(isInfo?.status < "2" || isInfo.status === "4") ? "text-[gray]" : "text-black"} text-[14px]`}>{t("On Route")}</h1>
                                    </div>
                                    <span className={`${isInfo?.status < "3" ? "text-[gray]" : "text-black"}`}>- - -</span>

                                    <div className="text-center">
                                        <img src={isInfo?.status < "3" ? complete_grey : isInfo.status === "4" ? cancel : complete_fill} alt="Deliver" />
                                        <h1 className={`${isInfo?.status < "3" ? "text-[gray]" : isInfo.status === "4" ? "text-[red]" : "text-green-500"} text-[14px]`}>{isInfo.status === "4" ? t("Cancel") : t("Deliver")}</h1>
                                    </div>
                                </div>
                            </div>

                            <div className="border-[1px] p-[10px] border-[#8080803b] rounded-[10px] mt-[10px]">
                                <h1 className='font-[500] text-[#0d9488] text-[17px]'>{t("Payment & Address Info")}</h1>
                                <ul>
                                    <li className='font-[500] text-gray-500 py-[3px]'>{t("Total Price")} : <span className='text-gray-600'>{currency} {isInfo?.tot_price}</span> </li>
                                    {isInfo?.wallet !== 0 && <li className='font-[500] text-gray-500 py-[3px]'>{t("Wallet Amount")} : <span className='text-gray-600'>{currency} {isInfo?.wallet}</span> </li>}
                                    <li className='font-[500] text-gray-500 py-[3px]'>{t("Product Amount")} : <span className='text-gray-600'>{currency} {isInfo?.sitter_amount}</span> </li>
                                    <li className='font-[500] text-gray-500 py-[3px]'>{t("Site Commission")} : <span className='text-gray-600'>{currency} {isInfo?.site_commission}</span> </li>
                                    {isInfo?.coupon_amount !== 0 && <li className='font-[500] text-gray-500 py-[3px]'>{t("Coupon Amount")} : <span className='text-gray-600'>{currency} {isInfo?.coupon_amount}</span> </li>}
                                    {isInfo?.wallet !== 0 && <li className='font-[500] text-gray-500 py-[3px]'>{t("Payment Method")} : <span className='text-gray-600'>(Pay from Wallet) & {isInfo?.payment_name}</span> </li>}
                                    {isInfo?.wallet === 0 && <li className='font-[500] text-gray-500 py-[3px]'>{t("Payment Method")} : <span className='text-gray-600'>{isInfo?.payment_name}</span> </li>}
                                    <li className='font-[500] text-gray-500 py-[3px]'>{t("Address")} : <span className='text-gray-600'>{isInfo?.house_no}, {isInfo?.address}, {isInfo?.landmark}</span> </li>
                                    <li className='font-[500] text-gray-500 py-[3px]'>{t("TransactionId")} : <span className='text-gray-600'>{isInfo?.transactionId}</span> </li>

                                    <div className='border-t-[2px] border-dashed'></div>

                                    {isInfo?.wallet !== 0 && <li className='font-[500] text-gray-500 py-[3px]'>{t("Paid from Wallet")}  : <span className='text-gray-600'>{currency} {isInfo?.wallet}.00</span> </li>}
                                    {isInfo?.online_amount !== 0 && <li className='font-[500] text-gray-500 py-[3px]'>{t("Online Paid")} : <span className='text-gray-600'>{currency} {isInfo?.online_amount}.00</span> </li>}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>}

            <Lightbox
                open={isShow}
                close={() => setIsShow(false)}
                slides={lightBox}
                index={lightBoxIndex}
                plugins={[Zoom]}
            />

        </div>
    )
}

export default OrderDetails
/* jshint ignore:end */